//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clientFollowDeleteApi, clientRecordApi } from '@/api/enterprise';
import { toSrcFn } from '@/utils/format';
import file from '@/utils/file';
import Vue from 'vue';
Vue.use(file);
export default {
  name: 'dynamicRecord',
  components: {
    ElImageViewer: function ElImageViewer() {
      return import('element-ui/packages/image/src/image-viewer');
    },
    recordUpload: function recordUpload() {
      return import('./recordUpload');
    },
    remindDialog: function remindDialog() {
      return import('./remindDialog');
    }
  },
  props: {
    formInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dynamicRecord: [],
      srcList: [],
      liaison: {},
      addRecordShow: false,
      isTitle: '添加跟进记录',
      textarea: '',
      isEdit: null,
      isImage: false,
      id: '',
      form: {
        content: '',
        files: [],
        types: 0,
        time: ''
      },
      editIndex: -1,
      remindConfig: {}
    };
  },
  methods: {
    getTableData: function getTableData() {
      var _this = this;
      this.dynamicRecord = [];
      this.liaison.eid = this.formInfo.data.eid;
      clientRecordApi(this.liaison).then(function (res) {
        _this.liaisonTotal = res.data.count;
        res.data.list.map(function (item, index) {
          if (index == 0) {
            item.icon = 'iconfont icondangqian';
          }
          _this.dynamicRecord.push(item);
        });
      });
    },
    // 关闭查看图片弹窗
    closeImageViewer: function closeImageViewer() {
      this.isImage = false;
      this.srcList = [];
    },
    getTypeStr: function getTypeStr(type) {
      var obj = {
        1: '转为公海客户',
        2: '领取客户',
        3: '标为流失',
        4: '取消流失',
        5: '移交客户'
      };
      return obj[type];
    },
    // 查看图片
    handlePictureCardPreview: function handlePictureCardPreview(row) {
      this.srcList.push(row);
      this.isImage = true;
    },
    uploadChange: function uploadChange(e) {
      if (e.type === 'add') {
        this.addRecordShow = false;
      } else {
        this.editIndex = -1;
      }
      this.getTableData();
    },
    // 下载文件
    downloadFile: function downloadFile(row, name) {
      this.fileLinkDownLoad(row, name);
    },
    // 添加
    addRecord: function addRecord() {
      this.formInfo.type = 'add';
      this.addRecordShow = !this.addRecordShow;
      this.isTitle = '添加跟进记录';
    },
    remindChange: function remindChange() {
      this.getTableData();
    },
    // 判断上传的文件格式文件是否有无图片，无图则为默认
    toSrc: function toSrc(e) {
      return toSrcFn(e);
    }
  }
};